import { ActionDropdown } from '@ctw/shared/components/dropdown/action-dropdown';
import { tw } from '@ctw/shared/utils/tailwind';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
let otherYear = currentYear - 1;
if (currentDate.getMonth() === 11) {
  // in December the other period will be the next year
  otherYear = currentYear + 1;
}
const defaultYearOptions = [currentYear.toString(), otherYear.toString()];

type PeriodDropdownProps = {
  selectedYear: string;
  onChange: (year: string) => void;
  yearOptions?: Array<string>;
};

export function PeriodDropdown({
  selectedYear,
  onChange,
  yearOptions = defaultYearOptions,
}: PeriodDropdownProps) {
  return (
    <ActionDropdown
      className={tw`max-h-[17.25rem] overflow-y-auto`}
      type="select"
      buttonClassName={tw`w-min max-h-[17.25rem] rounded-md border border-divider-main bg-transparent p-0 shadow-sm`}
      onItemSelect={(item) => {
        onChange(item.key);
      }}
      items={yearOptions.map((year) => ({
        key: year,
        name: year,
        isSelected: selectedYear === year,
      }))}
    >
      <div
        className={tw`flex items-center space-x-2 rounded-md border border-border-main border-transparent border-solid bg-white px-4 py-2 font-medium text-content-subtle text-sm shadow-sm hover:bg-background-hover`}
      >
        <FontAwesomeIcon icon={faCalendar} className={tw`w-4`} />
        <span className={tw`whitespace-nowrap`}>
          Measure Period: <span className={tw`font-normal`}>{selectedYear}</span>
        </span>
        <FontAwesomeIcon icon={faChevronDown} className={tw`ml-auto w-2`} />
      </div>
    </ActionDropdown>
  );
}
